import React from "react";
import { mapVacancyDistributions } from "../../jobs/mappers/vacancyDistributionMapper";
const LocationWiseVacancyTable = ({
  positionStateDistributions = [],
  states = [],
  centerMap = {},
  reservationCategories = [],
  disabilities = [],
  cities = [],
  exServicemenGroups = [],
}) => {
  const vacancyDistribution = mapVacancyDistributions(
    positionStateDistributions,
    states,
    centerMap,
    reservationCategories,
    disabilities,
    cities,
  );
  const groupedExServicemen = Object.values(
    exServicemenGroups.reduce((acc, item) => {
      if (!acc[item.groupId]) {
        acc[item.groupId] = {
          groupId: item.groupId,
          items: [],
        };
      }

      acc[item.groupId].items.push(item);

      return acc;
    }, {}),
  ).map((group) => ({
    ...group,
    label: group.items.map((item) => item.exsCategoryCode).join("/"),
  }));

  if (!vacancyDistribution.length) return null;
  return (
    <div className="info-card mt-3">
      <h6 className="card-section-header">
        Category Wise Reservation (State-wise)
      </h6>

      <div className="table-responsive">
        <table className="table table-bordered vacancy-table">
          <thead>
            <tr>
              <th rowSpan="2" style={{ width: "20%" }}>
                State
              </th>
              <th rowSpan="2" style={{ width: "20%" }}>
                City
              </th>
              <th
                colSpan={reservationCategories.length + 1}
                className="text-center"
              >
                Category
              </th>

              <th colSpan={disabilities.length} className="text-center">
                Disability
              </th>
              <th colSpan={groupedExServicemen.length} className="text-center">
                Ex-servicemen
              </th>
            </tr>

            <tr>
              {reservationCategories.map((cat) => (
                <th key={cat.category_id}>{cat.category_code}</th>
              ))}
              <th>Total</th>

              {disabilities.map((dis) => (
                <th key={dis.disability_id}>{dis.disability_code}</th>
              ))}

              {groupedExServicemen.map((group) => (
                <th key={group.groupId}>{group.label}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {vacancyDistribution.map((dist, index) => {
              const categoryTotal = reservationCategories.reduce(
                (sum, cat) => sum + (dist.categories?.[cat.category_id] || 0),
                0,
              );

              return (
                <tr key={index}>
                  <td>{dist.state_name}</td>
                  <td>{dist.city_name}</td>
                  {reservationCategories.map((cat) => (
                    <td key={cat.category_id}>
                      {dist.categories?.[cat.category_id] || 0}
                    </td>
                  ))}
                  <td>{categoryTotal}</td>

                  {disabilities.map((dis) => (
                    <td key={dis.disability_id}>
                      {dist.disability?.[dis.disability_id] || 0}
                    </td>
                  ))}

                  {groupedExServicemen.map((group) => (
                    <td key={group.groupId}>
                      {dist.exServicemen?.[group.groupId] ?? 0}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LocationWiseVacancyTable;
